import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { NotificationsService } from 'angular2-notifications';
import { UserFeedbackSender } from 'app/services/api/api-user-feedback.service';
import { NgxSpinnerService } from 'ngx-spinner';

enum SATISFACTION {
    SATISFACTED = 3,
    NEUTRAL = 2,
    DISFACTED = 1
};

@Component({
  standalone: false,
    selector: 'fuse-dialog-feedback',
    templateUrl: './dialog-feedback.component.html',
    styleUrls: ['./dialog-feedback.component.scss']
})
export class DialogFeedbakComponent implements OnInit {
    private ticketId: number;

    public satisfactionSelected: number;
    public submitted = false;
    public SATISFACTION = SATISFACTION;

    feedback: string = '';

    constructor(
        @Inject(MAT_DIALOG_DATA) public data: any,
        public dialogRef: MatDialogRef<DialogFeedbakComponent>,
        private userFeedbackSender: UserFeedbackSender,
        private toast: NotificationsService,
        private spinner: NgxSpinnerService,
    ) { }

    ngOnInit(): void {
        this.ticketId = this.data.ticketId;
    }

    satisfactionAccepted(satisfaction: number) {
        this.satisfactionSelected = satisfaction;
    }

    sendSatisfaction() {
        this.submitted = true;
        this.spinner.show();

        this.userFeedbackSender
            .send(this.ticketId, this.satisfactionSelected, this.feedback)
            .then(() => {
                this.toast.success('Gradimento', 'Inviato con successo');
                this.dialogRef.close();
            })
            .catch(() => {
                this.toast.error('Errore', 'Si prega di riprovare');
            })
            .finally(() => this.spinner.hide())
    }
}